import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ContentType, Scenarios } from 'containers/Onboarding/types';

import { Market } from 'graphql/generated/graphql';

import ReduxState from 'store/ReduxState';

export interface OnboardingAnswersState {
  contentTypes: ContentType[];
  tagIds: string[];
  scenarios: Scenarios[];
  storyMarkets: Market[];
  skipped: boolean;
  birthdayDate: string;
  relationshipStatus: string;
}

export const initialOnboardingResponsesState: OnboardingAnswersState = {
  contentTypes: [],
  tagIds: [],
  scenarios: [],
  storyMarkets: [],
  skipped: false,
  birthdayDate: '',
  relationshipStatus: '',
};

export const onboardingSlice = createSlice({
  name: 'onboarding_responses',
  initialState: initialOnboardingResponsesState,
  reducers: {
    setContentTypes: (state, action: PayloadAction<ContentType[]>) => {
      state.contentTypes = action.payload;
    },
    setTagIds: (state, action: PayloadAction<string[]>) => {
      state.tagIds = action.payload;
    },
    setScenarios: (state, action: PayloadAction<Scenarios[]>) => {
      state.scenarios = action.payload;
    },
    setStoryMarkets: (state, action: PayloadAction<Market[]>) => {
      state.storyMarkets = action.payload;
    },
    setSkipped: (state, action: PayloadAction<boolean>) => {
      state.skipped = action.payload;
    },
    setBirthdayDate: (state, action: PayloadAction<string>) => {
      state.birthdayDate = action.payload;
    },
    setRelationshipStatus: (state, action: PayloadAction<string>) => {
      state.relationshipStatus = action.payload;
    },
    clear: (_state, _action: PayloadAction) => {
      return initialOnboardingResponsesState;
    },
  },
});

export const getContentTypes = ({
  onboarding_responses,
}: {
  onboarding_responses: OnboardingAnswersState;
}): ContentType[] => onboarding_responses.contentTypes;

export const getTagIds = ({
  onboarding_responses,
}: {
  onboarding_responses: OnboardingAnswersState;
}): string[] => onboarding_responses.tagIds;

export const getScenarios = ({
  onboarding_responses,
}: {
  onboarding_responses: OnboardingAnswersState;
}): Scenarios[] => onboarding_responses.scenarios;

export const getStoryMarkets = ({
  onboarding_responses,
}: {
  onboarding_responses: OnboardingAnswersState;
}): Market[] => onboarding_responses.storyMarkets;

export const getAllResponses = ({
  onboarding_responses,
}: {
  onboarding_responses: OnboardingAnswersState;
}): OnboardingAnswersState => onboarding_responses;

export const getSkipped = (state: ReduxState): boolean =>
  state.onboarding_responses.skipped;

export const getBirthdayDate = (state: ReduxState): string =>
  state.onboarding_responses.birthdayDate;

export const getRelationshipStatus = (state: ReduxState): string =>
  state.onboarding_responses.relationshipStatus;

export const {
  clear,
  setContentTypes,
  setTagIds,
  setScenarios,
  setStoryMarkets,
  setSkipped,
  setBirthdayDate,
  setRelationshipStatus,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
